module.exports = __webpack_public_path__ + "static/republieklogo-53f7b7eeddde3557a7b55ec63d1b8e2b.png";